import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import UIAssetKeys from '../UIAssetKeys';

export default class ClickPointCircle extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);

    this.outerCircle = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._ClickCircle_Outer, this);
    this.innerCircle = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._ClickCircle_Inner, this);
  }

  displayClick (x,y) {
    this.x = x;
    this.y = y;
    this.scene.tweens.killTweensOf(this.outerCircle);
    this.scene.tweens.killTweensOf(this.innerCircle);
    this.outerCircle.scale = 0;
    this.innerCircle.scale = 0;

    this.innerCircle.alpha = 1;
    this.outerCircle.alpha = 1;

    ABCyaPhaser.Tweens.addTween([this.innerCircle, this.outerCircle], 140, { scale: 1 }, Phaser.Math.Easing.Linear);
    ABCyaPhaser.Tweens.addTween([this.innerCircle, this.outerCircle], 120, { delay: 140,alpha: 0 }, Phaser.Math.Easing.Linear);
  }
}